import { getDateFromToday } from '@common/utils/dates';

const start = new Date(getDateFromToday(60));
const end = new Date(getDateFromToday(0));
const utcStart = new Date(start.getTime() + start.getTimezoneOffset() * 60000);
const utcEnd = new Date(end.getTime() + end.getTimezoneOffset() * 60000);
const startDate = utcStart.toISOString();
const endDate = utcEnd.toISOString();

export const USER_REQUEST_PARAMS = {
  autobcc: null,
  block: '',
  csvtreenodebindings: [],
  csvfilter: {
    data: [],
    errors: []
  },
  excludeCSV: false,
  exclusions: {
    googlegroupbindings: [],
    o365groupbindings: [],
    oktagroupbindings: []
  },
  dateRange: {
    startDate,
    endDate
  },
  googleDateRange: {
    startDate,
    endDate
  },
  filterByDate: false,
  filterByGoogleDate: false,
  fieldname: '',
  fieldregex: '',
  googlecountrybindings: [],
  googlegroupbindings: [],
  hasBrokenSyncs: false,
  hasHttpImages: null,
  hasUnlockedFields: false,
  hideAddin: null,
  hideNeverSent: true,
  hideNeverUsed: false,
  hideRemoved: true,
  isEmpty: null,
  imgSrcCheck: null,
  imgsrc: '',
  includeSigs: false,
  images: null,
  keyword: '',
  links: null,
  notblock: false,
  skewedImages: false,
  o365groupbindings: [],
  oktagroupbindings: [],
  page: 1,
  perPage: 25,
  query: '',
  roles: [],
  sendergroup: '',
  sales: null,
  systemFilter: [],
  systemFilterOptions: [],
  userparamname: '',
  userparamregex: ''
};
